// For Get insurance_carriers
export const GET_USER_ACTIVITY = "GET_USER_ACTIVITY"
export const GET_USER_ACTIVITY_SUCCESS = "GET_USER_ACTIVITY_SUCCESS"
export const GET_USER_ACTIVITY_ERROR = "GET_USER_ACTIVITY_ERROR"

export const GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY = "GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY"
export const GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS = "GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS"
export const GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR = "GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR"

export const UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY =  "UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY"
export const UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS =  "UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_SUCCESS"
export const UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR =  "UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY_ERROR"